/* eslint-disable max-len */
import React ,{useContext} from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import AnimatedButton from '../../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { toggleRowSelection } from '../../../../redux/MultiselectRows'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import GlobalContext from '../../../../components/Context/GloablContext'
import { handleEditMessageSent } from '../../../../redux/systemConfigSlice'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber'
const TableBody=({tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg})=>{
    const navigate=useNavigate()
    const auth=useSelector(state=>state?.auth)
    const {userType}=auth
    const dispatch=useDispatch()
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams,setSearchParams]=useSearchParams({})
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const { setToastErrorMessage ,sendMessageToStartEditing,receiveMessageFromSocket,editSocket} = useContext(GlobalContext);
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
       
    }
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        navigate(`/manage-organizations/${tableData?._id}` ,{state:Array.isArray(location.state)?'':Object.fromEntries(searchParams)})
                    }
                }}
                child={
                    <>
                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{tableData?.organization_id || '-'}</td>
                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{tableData?.organization_name || '-'}</td>
                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.organization_main_country_code && tableData?.main_number
                                ? `${tableData.organization_main_country_code} ${formatMobileNumber(tableData.main_number)}`
                                : '-'
                            }
                        </td>
                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{tableData?.value_added === true ? 'True' : 'False'}</td>
                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{tableData?.direct_billing === true ? 'True' : 'False'}</td>
                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className={`px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.map((item)=>item.id).includes(tableData?.user_id)?'bg-[#F8EEF1]':'bg-white '} last-td`}>
                            <div  className="relative flex items-center justify-center prevent-click" data-te-dropdown-ref>
                                <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click"
                                    id={"id"}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    data-testid="action-bar"
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                </button>
                                {selectedIndex===indexNum&& <ul  ref={selectedRef}  className={`border border-[#C2DCEF] p-2.5 absolute z-[99] float-left m-0 ${lastIndex === indexNum+1 ? ' top-[0px]' : ' top-0'} right-[88px] 2xl:right-[97px] min-w-[135px] list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >
                                    
                                           
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => {}}
                                            buttonName={"View"}
                                            locnState={Object.fromEntries(searchParams)}
                                            link={`/manage-organizations/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => {
                                                if(!messageSent){
                                                   
                                                    sendMessageToStartEditing(tableData?.organization_id)
                                                    let message
                                                    editSocket.onmessage = (event) =>{
                                                        message = event.data

                                                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                                                          
                                                            navigate(`/manage-organizations/add-organization/${tableData._id}`,{state:Object.fromEntries(searchParams)})
                                                        } else{
                                                            dispatch(handleEditMessageSent(false))
                                                            
                                                            { (JSON.parse(message)?.adminId) &&
                                                                setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this organization`)
                                                            }
                                                        }
                                                    }    
                                                }
                                                
                                            }}
                                            buttonName={"Edit"}
                                            locnState={Object.fromEntries(searchParams)}
                                            // link={`/manage-organizations/add-organization/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <div className='absolute top-[12px] right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0'>

                                    </div> 
                                </ul>}
                                
                            </div>
                        </td>
                    </>
                    
                }/>
           
        </>
    )
}
export default TableBody;